import comp from "./StudentResponse";
export default comp;
